import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export function convertFilterDataToSupervisionTypesIds<T extends { id: ISelectOption['id'] }>(
  options: IDictionarySupervisionTypeSelectOption[] | undefined,
  data: T[],
): string[] | undefined {
  return options
    ?.filter(item => data.find(supervisionType => supervisionType.id.toString() === item.id.toString()))
    .map(item => item.value.dictVersionId);
}
